<template>
  <div class="import-main">
    <Space wrap>
    </Space>
    <div class="header_top">
      <div class="import_btn">
        导入
        <input
          type="file"
          accept=".xls,.xlsx"
          class="upload_file"
          @change="readExcel($event)"
        />
      </div>
      <!-- <Button type="success" @click="toimage">获取图片地址</Button> -->
    </div>

    <Table :columns="columns" :data="lists" height="500"></Table>
    <div class="submit_box">
      <Poptip
        confirm
        title="是否将数据导入列表中?"
        @on-ok="onClickSubmit"
        @on-cancel="cancel"
      >
        <Button type="success">提交数据</Button>
      </Poptip>
    </div>
    <br />
    <br />
  </div>
</template>

<script>
import XLSX from "xlsx";
import Image from "@/views/device/image.vue";

export default {
  name: "",
  components: {
    Image,
  },
  props: {
    refListTable: {
      type: Function,
    },
  },
  data() {
    return {
      columns: [
        {
          title: "序号",
          key: "no",
          minWidth: 80,
          align: "left",
          copy: true,
        },
        {
          title: "错误描述",
          minWidth: 180,
          align: "left",
          key: "descr",
          viewimage: true,
        },

        {
          title: "耗材名称",
          key: "name",
          minWidth: 120,
          align: "left",
          copy: true,
        },
        {
          title: "耗材编号",
          key: "consumableNum",
          minWidth: 120,
          align: "left",
          copy: true,
        },
        {
          title: "耗材分类",
          key: "type",
          minWidth: 100,
          align: "left",
        },
        {
          title: "耗材型号",
          key: "model",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.model;
            return h(
              "div",
              {
                style: {
                  margin: "5px",
                  "font-size": "14px",
                  width: "150px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "耗材品牌",
          key: "brand",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                  domProps: {
                    title: params.row.brand,
                  },
                },
                params.row.brand
              ),
            ]);
          },
        },
        {
          title: "性能参数",
          key: "performanceParameter",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                  domProps: {
                    title: params.row.performanceParameter,
                  },
                },
                params.row.performanceParameter
              ),
            ]);
          },
        },
        {
          title: "耗材图片",
          minWidth: 120,
          align: "left",
          key: "consumableImgUrl",
          viewimage: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.consumableImgUrl;
            return <img src={text} style="width: 100px;height:100px"/>;
          },
        },
        {
          title: "耗材数量",
          key: "num",
          minWidth: 100,
          align: "left",
          copy: true,
        },
        {
          title: "采购人",
          key: "purchase",
          minWidth: 100,
          align: "left",
          copy: true,
        },
        {
          title: "中标单价",
          key: "unitPrice",
          minWidth: 100,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.unitPrice;
            return h(
              "div",
              {
                style: {
                  margin: "5px",
                  "font-size": "14px",
                  width: "150px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        // {
        //   title: "市场价",
        //   key: "jdPrice",
        //   minWidth: 100,
        //   align: "left",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.jdPrice;
        //     return h(
        //         "div",
        //         {
        //           style: {
        //             margin: "5px",
        //             "font-size": "14px",
        //             width: "150px",
        //             overflow: "hidden",
        //             "text-overflow": "ellipsis",
        //             "white-space": "nowrap",
        //           },
        //         },
        //         text
        //     );
        //   },
        // },
        {
          title: "单位",
          key: "unit",
          minWidth: 100,
          align: "left",
          copy: true,
        },

        {
          title: "采购时间",
          key: "purchaseTime",
          minWidth: 180,
          align: "left",
        },
        {
          title: "适用设备",
          key: "remark",
          minWidth: 180,
          align: "left",
        },
        {
          title: "是否可领用",
          key: "receiveState",
          minWidth: 180,
          align: "left",
        },

        // {
        //   title: '导入状态',
        //   key: 'state',
        //   minWidth: 100,
        //   align: 'center',
        //   fixed: 'right',
        //   render: (h, params) => {
        //     const row = params.row
        //     const text = row.state == 1 ? '成功' : row.state == 2 ? '失败' :row.state == 3 ? '重复':''
        //     return <span style={{ 'font-size': '14px', color: row.state == 1 ? '#12C3B5' : row.state == 2 ? 'red' :row.state == 3 ? '#ffb11b' : '' }}>{text}</span>
        //   },
        // },
      ],
      lists: [],
      oldList: [],
    };
  },
  computed: {},
  created() {},
  methods: {
    readExcel(e) {
      // 读取表格文件
      let that = this;
      const files = e.target.files;
      if (files.length <= 0) {
        return false;
      } else if (!/.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$message({
          message: "上传格式不正确，请上传xls或者xlsx格式",
          type: "warning",
        });
        return false;
      } else {
        // 更新获取文件名
        that.upload_file = files[0].name;
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) || []; //生成json表格内容
          that.lists = [];
          // 从解析出来的数据中提取相应的数据
          ws.forEach((item) => {
            if (!isNaN(parseFloat(item["采购时间"]))) {
              //   //2.如果是纯数字 如果数字小于10万 那么就是日期格式 需要进行转换
              if (item["采购时间"] < 100000) {
                let time = new Date((item["采购时间"] - 25567) * 24 * 3600000 - 5 * 60 * 1000 - 43 * 1000 - 24 * 3600000 - 8 * 3600000)
                let year = time.getFullYear() + '-'
                let month = time.getMonth() + 1 + '-'
                let date = time.getDate() + ''
                item["采购时间"] = year + month + date
              }
            }
            that.lists.push({
              no: item["__rowNum__"] + 1,
              name: item["耗材名称"],
              consumableNum: item["耗材编号"],
              type: item["耗材分类"],
              model: item["耗材型号"],
              brand: item["耗材品牌"],
              performanceParameter: item["性能参数"],
              consumableImgUrl: item["耗材图片"],
              num: item["耗材数量"],
              purchase: item["采购人"],
              unitPrice: item["中标单价"],
              jdPrice: item["市场价"],
              unit: item["单位"],
              purchaseTime: item["采购时间"],
              remark: item["适用设备"],
              receiveState: item["是否可领用"],
            });
          });
        } catch (e) {
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      e.target.value = "";
    },
    onClickSubmit() {
      if (this.lists.length == 0) {
        this.$Modal.remove();
        return;
      }
      this.$Spin.show(
        {
          render: (h) => {
            return h('div', [
              h('Icon', {
                'class': 'demo-spin-icon-load',
                "style": "animation: ani-demo-spin 1s linear infinite",
                props: {
                  type: 'ios-loading',
                  size: 18
                }
              }),
              h('div', 'Loading')
            ])
          }
        });
      // this.lists.map((item) => {
      //   if (item.sendType == '手动') {
      //     item.sendType = 1
      //   } else {
      //     item.sendType = 2
      //   }
      //   if (item.state == '成功') {
      //     item.state = 1
      //   } else {
      //     item.state = 2
      //   }
      //   if (item.maintainType == '维修类型') {
      //     item.maintainType = 1
      //   } else {
      //     item.maintainType = 2
      //   }
      // })
      $utils.api
        .load(`/admin/system/inventory/listConsumable`, this.lists, "POST")
        .then((res) => {
          if (res.code == 200) {
            this.lists = res.data || [];
            this.oldList = res.data || [];
            let arr = res.successTotal || 0;
            // this.lists.map((item) => {
            //   if (item.state == 1) {
            //     arr.push(item)
            //   }
            // })
            $utils.toast.success(`导入成功`);
            this.refListTable();
            this.$Spin.hide()
            this.$Modal.remove();
          }
          if (res.code == 500) {
             this.lists = res.data || []
            this.oldList = res.data || []
            this.$Spin.hide()
          }
        })
        .catch((e) => {
          this.$Spin.hide()
          $utils.toast.error("导入异常" + e.message);
        });
    },
    toimage() {
      this.$Modal.remove();
      setTimeout(() => {
        this.$Modal.success({
          closable: true,
          title: "图片",
          width: 300,
          okText: "关闭",
          showOk: false,
          render: (h) => {
            return <Image style={{ margin: "0", color: "#19be6b" }} ></Image>;
          },
        });
      }, 500);
    },
    //js XLSX读取 excel 转换日期格式
    getFormatDate_XLSX(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);
      var fractional_day = serial - Math.floor(serial) + 0.0000001;
      var total_seconds = Math.floor(86400 * fractional_day);
      var seconds = total_seconds % 60;
      total_seconds -= seconds;
      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;
      var d = new Date(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds
      );
      //得到Date()对象后，便可进行日期格式化了！
      var add0 = (m) => (m < 10 ? "0" + m : m);
      var YYYY = d.getFullYear();
      var MM = add0(d.getMonth() + 1);
      var DD = add0(d.getDate());
      var hh = add0(d.getHours());
      var mm = add0(d.getMinutes());
      var ss = add0(d.getSeconds());
      return `${YYYY}-${MM}-${DD} ${hh}:${mm}:${ss}`;
    },
  },
};
</script>
<style lang="less" scoped>
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}
.header_top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 20px;
}
.import_btn {
  width: 60px;
  height: 35px;
  border-radius: 10px;
  background-color: #fb9338;
  text-align: center;
  line-height: 35px;
  position: relative;
  color: #fff;
  .upload_file {
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
  }
}
.submit_box {
  // width: 100px;
  float: right;
  margin-top: 20px;
  margin-left: 15px;
}
</style>
